import { ResponsiveGrid } from "@adobe/aem-react-editable-components"
import MAPPED_COMPONENTS from "../AEM/import-components-shared"
import MAPPED_RESPONSIVE_GRID_ONLY_COMPONENTS from "../AEM/import-components-aem-content-parser"

const AEMContentParser = ({ model, modelPath }) => (
  <ResponsiveGrid
    // This is a bit of a hack, but setting the key prop to the modelPath solves a bug in the ResponsiveGrid component where the rendered components are not updated as the model and modelPath change by forcing an update
    key={modelPath}
    model={model}
    pagePath={modelPath}
    itemPath={process.env.NEXT_PUBLIC_AEM_MODEL_ITEM_PATH}
    components={{
      ...MAPPED_COMPONENTS,
      ...MAPPED_RESPONSIVE_GRID_ONLY_COMPONENTS,
    }}
  />
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// AEMContentParser.propTypes = {
//   model: PropTypes.object.isRequired,
//   modelPath: PropTypes.string.isRequired,
// }

export default AEMContentParser
